const THEME = {
  STANDARD: 'standard',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export { THEME };

export enum NotificationTheme {
  Standard = 'standard',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
}
